// Version: 1.1
// v1.1: Buttons use the shared button system (CV-49): 8px corners, standard variants and sizes, one selected look; no inline radius, padding or font size.
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './auth';
import './Login.css';

// Microsoft redirects the browser here after the user signs in, with
// ?code=...&state=... in the URL. This page hands those off to the API
// (which never talks to Microsoft's browser-facing redirect directly) and
// then either completes the session or routes into the existing MFA flow,
// exactly like the password login path does.
export default function MicrosoftCallback() {
  const navigate = useNavigate();
  const { completeMicrosoftLogin } = useAuth();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke guard — code is single-use
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code  = params.get('code');
    const state = params.get('state');
    const msError = params.get('error_description') || params.get('error');

    if (msError) {
      setError('Microsoft sign-in was cancelled or denied.');
      return;
    }
    if (!code || !state) {
      setError('Missing sign-in details from Microsoft. Please try again.');
      return;
    }

    (async () => {
      try {
        const data = await completeMicrosoftLogin(code, state);
        if (data.mfa_required) {
          navigate('/mfa', {
            state: {
              pre_token:  data.pre_token,
              username:   data.username,
              email_hint: data.username.slice(0, 3) + '***'
            }
          });
          return;
        }
        if (data.password_change_required) {
          navigate('/change-password');
        } else if (data.role === 'client' && data.client_slug) {
          navigate('/clients/' + data.client_slug);
        } else {
          navigate('/dashboard');
        }
      } catch (err) {
        setError(err.message);
      }
    })();
  }, []);

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <span className="login-logo-stg">STG</span>
            <span className="login-logo-sep" />
            <span className="login-logo-sub">Portal</span>
          </div>
          <div className="login-tagline">Signing you in…</div>
        </div>
        <div className="login-body" style={{textAlign:'center'}}>
          {error ? (
            <>
              <div className="error-msg">{error}</div>
              <button className="btn btn-primary btn-lg login-btn" style={{ marginTop: 16 }}
               
               
                onClick={() => navigate('/login')}
              >
                Back to sign in
              </button>
            </>
          ) : (
            <span className="spinner" />
          )}
        </div>
      </div>
    </div>
  );
}
